export const CHATBOT_SESSIONS_GET_ALL_REQUEST =
  "CHATBOT_SESSIONS_GET_ALL_REQUEST";
export const CHATBOT_SESSIONS_GET_ALL_SUCCESS =
  "CHATBOT_SESSIONS_GET_ALL_SUCCESS";
export const CHATBOT_SESSIONS_GET_ALL_FAIL = "CHATBOT_SESSIONS_GET_ALL_FAIL";
